import { useState } from 'react';
import AddBoxIcon from '@mui/icons-material/AddBox';
import CreateHook from '../../components/CreateHook/CreateHook';
import HookList from '../../components/HookList/HookList';
import Hamburger from '../../components/HamburgerMenu/HamburgerMenu';

export function HookRoute() {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  return (
    <>
      {anchorEl && (
        <div className="popper">
          <CreateHook anchorEl={anchorEl} onClose={handleClick} />
        </div>
      )}
      <div className="topActions">
        <Hamburger></Hamburger>
        <h1>Hook Monitor</h1>
        <div className="tophookButtons">
          <button
            style={{
              display: 'flex',
            }}
            onClick={handleClick}
          >
            <AddBoxIcon size="small" />
            Add Hook
          </button>
        </div>
      </div>
      <HookList />
    </>
  );
}
